import PageviewChart from "../widgets/PageviewChart";
import Helper from "../../utils/helper";
import TopPostsList from "../TopPostsList";
import TopReferrerList from "../TopRefererList";
import {useNumberOfDays} from "../../hook/useConfig";
import {useQueryStatePageviews} from "../../hook/useQuery";
import {PAGEVIEWS_AGGREGATION_DAY} from "../../data/repository";
import {useDayEnd, useDayStart} from "@octavius-rocks/ui";

export default function StatisticsRocksWidget(){

	const getDayStart = useDayStart();
	const getDayEnd = useDayEnd();

	const [numberOfDays, setNumberOfDays] = useNumberOfDays(14, "pageviews");
	let x_days_before = new Date(Date.now() - (numberOfDays-1) * 24 * 3600 * 1000);
	const start = new Date(Helper.toDateString(x_days_before, true));
	const end =  new Date(Helper.toDateString(new Date(), true));

	const startDateFormat = Helper.dateformat(start, "dd.mm.yyyy");
	const endDateFormat = Helper.dateformat(end, "dd.mm.yyyy");

	const dayStart = getDayStart(start);
	const dayEnd = getDayEnd(end);

	const pageviews = useQueryStatePageviews('wpDashboardWidget', {
		event_type: "pageview",
		from: dayStart,
		to: dayEnd,
		numberOfItems: 10,
	});

	return (
		<div>
			<h2 className="ocdb-view-title">
				Pageviews der vergangenen 
				<input type="number" value={numberOfDays} onChange={(e)=>setNumberOfDays(e.target.value)} />
				Tage
			</h2>
			<p className="ocdb-from-to">
				Pageviews vom {startDateFormat} bis {endDateFormat}
			</p>
			<PageviewChart value={pageviews} aggregation={PAGEVIEWS_AGGREGATION_DAY} />

			<h3 className="ocdb-view-subtitle">Top Beiträge</h3>
			<div className="ocdb-section-wrapper">
				<div className="ocdb-section">
					<TopPostsList from={dayStart} to={dayEnd} numberPosts={5}/>
				</div>
			</div>
			<h3 className="ocdb-view-subtitle">Top vermittelnde Domains</h3>
			<div className="ocdb-section-wrapper">
				<div className="ocdb-section">
					<TopReferrerList from={dayStart} to={dayEnd} numberReferrer={5}/>
				</div>
			</div>
		</div>
	)
}
